import Ajax from "Utils/ajax";
export const getAllRoles = (data) => Ajax.post('admin/getAllRolesForDropDown',data);
export const getAllUsersByRoleId = (data) => Ajax.post('admin/getAllUsersByRoleId',data);
export const addUpdateUserByRole = (data) => Ajax.post('admin/addUpdateUserByRole',data);
export const getAllocatedUserByRole = (data) => Ajax.post('admin/getAllocatedUserByRole',data);